import { render, staticRenderFns } from "./NhapLieuCtyTTChung.vue?vue&type=template&id=798b6454&scoped=true"
import script from "./NhapLieuCtyTTChung.vue?vue&type=script&lang=ts"
export * from "./NhapLieuCtyTTChung.vue?vue&type=script&lang=ts"
import style0 from "./NhapLieuCtyTTChung.vue?vue&type=style&index=0&id=798b6454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b6454",
  null
  
)

export default component.exports